import { render, staticRenderFns } from "./StoryInfo.vue?vue&type=template&id=1565f63f&"
import script from "./StoryInfo.vue?vue&type=script&lang=js&"
export * from "./StoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports